// extracted by mini-css-extract-plugin
export default {"goBackText":"GoBack_goBackText__jRm9O","label":"GoBack_label__jzABT","goBackButton":"GoBack_goBackButton__abrIn"};